export default {
  AUTH: {
    LOGIN: {
      META: { TITLE: 'Sign in' },
      SIGN_IN: 'Sign in to wokap',
      GOOGLE: 'Continue with Google',
      LINKEDIN: 'Continue with LinkedIn',
      OR: 'Or continue with email',
      FORM: {
        EMAIL: 'Email address',
        PASSWORD: 'Password',
        SUBMIT: 'Sign in',
      },
      NO_ACCOUNT: {
        QUESTION: 'Don\'t have an account?',
        REGISTER: 'Sign up',
      },
      RECOVER_PASSWORD: {
        QUESTION: 'Forgot your password?',
        CHANGE_PASSWORD: 'Reset it here',
      },
      ERRORS: {
        DEFAULT: 'Incorrect email or password. Please try again.',
        WRONG_PASSWORD: 'Incorrect email or password.',
        USER_NOT_FOUND: 'User does not exist or does not have access to wokap.',
        ENTITY_DELETED: 'The company has been deleted. Please contact support for more information.',
        ENTITY_DISABLED: 'Your company is still being activated. We will notify you by email when it is ready.',
        USER_DISABLED: 'Your account is disabled. Please contact your company administrator.',
      },
    },
    REGISTER: {
      META: { TITLE: 'Sign up' },
      SIGN_UP: 'Sign up for wokap',
      SUBTITLE: 'Complete your details to create your account. You will then set up your company.',
      GOOGLE: 'Continue with Google',
      LINKEDIN: 'Continue with LinkedIn',
      OR: 'Or sign up with email',
      FORM: {
        NAME: 'First name',
        LASTNAME: 'Last name',
        COMPANY_POSITION: 'Job title',
        EMAIL: 'Email address',
        PHONE: 'WhatsApp',
        PHONE_HELP: 'Phone number (e.g., +12345678900)',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm password',
        TERMS: {
          LABEL: 'I confirm that I have read and agree to the ',
          LINK: 'Terms of Service',
          LABEL_2: ' and the ',
          PRIVACY_LINK: 'Privacy Policy',
          PRIVACY_LABEL_2: ', including the use of cookies and similar technologies, and the processing of my activity on wokap.',
        },
        SUBMIT: 'Sign up',
      },
      ACCOUNT: {
        QUESTION: 'Already have an account?',
        LOGIN: 'Sign in',
      },
      ERRORS: {
        EMAIL_NOT_BLANK: 'Email is required',
        EMAIL_NOT_VALID: 'Please enter a valid email',
        EMAIL_ALREADY_USED: 'This email is already registered.\nIf you\'re creating a new company, use a different email.',
        PASSWORD_NOT_BLANK: 'Password is required',
        PASSWORD_MIN_LENGTH_3: 'Password must be at least 3 characters',
        FIRSTNAME_NOT_BLANK: 'First name is required',
        FIRSTNAME_MIN_LENGTH_3: 'First name must be at least 3 characters',
        LASTNAME_NOT_BLANK: 'Last name is required',
        LASTNAME_MIN_LENGTH_3: 'Last name must be at least 3 characters',
        ERROR_CREATING_USER: 'Something went wrong. Please try again.',
        PHONE_INVALID: 'Invalid phone number',
      },
    },
    PROFILE: {
      TITLE: 'Profile',
      LABELS: {
        FIRST_NAME: 'First name',
        LAST_NAME: 'Last name',
        GROUP: 'Role',
        EMAIL: 'Email address',
      },
      PLACEHOLDER: {
        FIRST_NAME: 'Enter first name',
        LAST_NAME: 'Enter last name',
        EMAIL: 'Enter email address',
      },
      GROUP_INFO: { TEXT_1: 'Need additional permissions? Reach out to your workspace admin to update your role and unlock more features in wokap.' },
      SAVE: 'Save changes',
      DISCARD: 'Discard',
      SUCCESS: 'Profile updated successfully.',
      ERRORS: {
        FIRSTNAME_NOT_BLANK: 'First name is required',
        LASTNAME_NOT_BLANK: 'Last name is required',
      },
      CONFIRMATION: {
        HEADER: 'Unsaved changes',
        MESSAGE: 'You have unsaved changes. Are you sure you want to leave this page?',
      },
      CROP_IMAGE: {
        TITLE: 'Crop image',
        CONFIRM: 'Apply',
      },
    },
    RECOVER_PASSWORD: {
      META: { TITLE: 'Reset password' },
      BACK: 'Back to sign in',
      STEP_1: {
        TITLE: 'Reset password',
        FORM: {
          USERNAME: 'Email address',
          SUBMIT: 'Send reset link',
        },
        SUCCESS: {
          RECOVERY_CHECK_EMAIL: 'We\'ve sent an email with a code to your inbox, enter it below.',
          RECOVERY_EMAIL_ALREADY_SEND: 'We\'ve sent an email with a code to your inbox.',
        },
        ERRORS: { DEFAULT: 'Invalid email address' },
      },
      STEP_2: {
        TITLE: 'Enter verification code',
        FORM: { SUBMIT: 'Verify' },
        ERRORS: { DEFAULT: 'This code has expired or is invalid.' },
      },
      STEP_3: {
        TITLE: 'Create new password',
        FORM: {
          NEW_PASSWORD: 'New password',
          CONFIRM_PASSWORD: 'Confirm new password',
          SUBMIT: 'Update password',
        },
        SUCCESS: 'Your password has been updated.',
        ERRORS: {
          EMAIL_NOT_BLANK: 'Invalid email address',
          EMAIL_NOT_VALID: 'Invalid email address',
          TOKEN_NOT_BLANK: 'This code has expired or is invalid.',
          PASSWORDS_NOT_MATCH: 'Passwords don\'t match.',
          NEW_PASSWORD_NOT_BLANK: 'Password is required.',
          NEW_PASSWORD_MIN_LENGTH_3: 'Password must be at least 3 characters.',
          NEW_PASSWORD_R_NOT_BLANK: 'Please confirm your password.',
          NEW_PASSWORD_R_MIN_LENGTH_3: 'Password must be at least 3 characters.',
          RECOVERY_TIME_EXPIRED: 'This code has expired or is invalid.',
          USER_NOT_FOUND_INCORRECT_TOKEN: 'This code has expired or is invalid.',
        },
      },
    },
    CHANGE_PASSWORD: {
      TITLE: 'Change password',
      FORM: {
        OLD_PASSWORD: 'Current password',
        PASSWORD: 'New password',
        REPEAT_PASSWORD: 'Confirm new password',
        PLACEHOLDER: {
          OLD_PASSWORD: 'Enter current password',
          PASSWORD: 'Enter new password',
          REPEAT_PASSWORD: 'Confirm new password',
        },
        CANCEL: 'Cancel',
        SUBMIT: 'Update password',
      },
      SUCCESS: 'Your password has been updated.',
      ERRORS: {
        DEFAULT: 'An unexpected error occurred.',
        PASSWORDS_NOT_MATCH: 'Passwords don\'t match.',
        NEW_PASSWORD_NOT_BLANK: 'New password is required.',
        NEW_PASSWORD_MIN_LENGTH_3: 'New password must be at least 3 characters.',
        NEW_PASSWORD_R_NOT_BLANK: 'Please confirm your new password.',
        NEW_PASSWORD_R_MIN_LENGTH_3: 'New password must be at least 3 characters.',
        USER_DISABLED: 'This account is disabled.',
        OLD_PASSWORD_INCORRECT: 'Current password is incorrect.',
        OLD_PASSWORD_NOT_CORRECT: 'Current password is incorrect.',
        USER_NOT_FOUND: 'User not found.',
      },
    },
  },
} as const;
